import { useContext } from "react";
import { AuthContext, AuthContextType } from "./AuthContext";

const useAuthentication = (): AuthContextType => {
  const contextValue = useContext(AuthContext);
  if (contextValue.userInfo === undefined) {
    throw new Error("UserInfo is not initialized");
  }
  return contextValue;
};

export default useAuthentication;
